/**
 * Customer navigation for the MyStudio mobile/tablet app shell.
 */

import Navi from "./Navi";

import { ReactComponent as IconHome } from "./Navi/icon/navi1.svg";
import { ReactComponent as IconSchedule } from "./Navi/icon/navi2.svg";
import { ReactComponent as IconProduct } from "./Navi/icon/navi4.svg";
import { ReactComponent as IconTheme } from "./Navi/icon/navi5.svg";
import { ReactComponent as IconMypage } from "./Navi/icon/navi6.svg";

import { ReactComponent as IconHomeAct } from "./Navi/icon/navi1-act.svg";
import { ReactComponent as IconScheduleAct } from "./Navi/icon/navi2-act.svg";
import { ReactComponent as IconProductAct } from "./Navi/icon/navi4-act.svg";
import { ReactComponent as IconThemeAct } from "./Navi/icon/navi5-act.svg";
import { ReactComponent as IconMypageAct } from "./Navi/icon/navi6-act.svg";

import { NaviItemType } from "./interface/Navi.interface";

const naviItemList: NaviItemType[] = [
    {
        name: "홈",
        icon: IconHome,
        icon_act: IconHomeAct,
        navigate: "/tabs/home",
        activePaths: ["/", "/myHome", "/mobile", "/tablet"],
    },
    {
        name: "촬영 일정",
        icon: IconSchedule,
        icon_act: IconScheduleAct,
        navigate: "/tabs/schedules",
        activePaths: ["/reservationHome", "/selectTheme", "/photoList", "/photoDetail"],
    },
    {
        name: "제품 신청",
        icon: IconProduct,
        icon_act: IconProductAct,
        navigate: "/tabs/products",
        activePaths: ["/productList", "/productDetail", "/productConfirm", "/productRequestEdit"],
    },
    {
        name: "촬영 테마",
        icon: IconTheme,
        icon_act: IconThemeAct,
        navigate: "/tabs/themes",
        activePaths: ["/themeBook"],
    },
    {
        name: "마이페이지",
        icon: IconMypage,
        icon_act: IconMypageAct,
        navigate: "/tabs/mypage",
        activePaths: ["/myPage", "/paymentHistory", "/changePassword", "/myInfo", "/qnaList", "/faqList"],
    },
];

const CustomerNavi = () => {
    return (
        <Navi
            navi_item_list={naviItemList}
        />
    );
};

export default CustomerNavi;
